<div class="rgb" [class.rce-section-invalid]="groupErrorCount > 0"
     [attr.data-rce-path]="groupPath">

  <!-- Group header ──────────────────────────────────────────────── -->
  <div class="rgb-header">
    <span class="rgb-title" i18n="@@Group">Group</span>
    <span class="rgb-summary" *ngIf="(group.characteristics || []).length > 0">
      {{group.characteristics.join(' × ')}}
    </span>
    <span class="rgb-spacer"></span>
    <span class="rce-error-badge" *ngIf="groupErrorCount > 0"
          [matTooltip]="groupErrorCount + ' validation error(s) on this group'">
      <mat-icon>error</mat-icon>{{groupErrorCount}}
    </span>
    <button mat-stroked-button class="rgb-toggle-controls"
            (click)="toggleBuilderControls()"
            [attr.aria-expanded]="builderControlsExpanded"
            i18n-matTooltip="@@Show or hide group setup (characteristics and matrix layout)"
            matTooltip="Show or hide group setup (characteristics and matrix layout)">
      <mat-icon>{{builderControlsExpanded ? 'unfold_less' : 'unfold_more'}}</mat-icon>
      <span i18n="@@Characteristics setup">Characteristics setup</span>
    </button>
    <button mat-stroked-button class="rgb-delete-group"
            (click)="confirmDeleteGroup()" [disabled]="readOnly"
            i18n-aria-label="@@Delete group" aria-label="Delete group"
            i18n-matTooltip="@@Delete group" matTooltip="Delete group">
      <mat-icon>delete</mat-icon>
      <span i18n="@@Delete group">Delete group</span>
    </button>
  </div>

  <!-- Characteristic chips ─────────────────────────────────────── -->
  <div class="rgb-chips" *ngIf="builderControlsExpanded">
    <span class="rgb-chips-label" i18n="@@Characteristics:">Characteristics:</span>
    <button mat-stroked-button *ngFor="let c of availableCharacteristics"
            class="rgb-chip"
            [class.rgb-chip-on]="isCharacteristicSelected(c)"
            [disabled]="readOnly"
            (click)="toggleCharacteristic(c)">
      <mat-icon *ngIf="isCharacteristicSelected(c)">check</mat-icon>
      <span>{{characteristicLabel(c)}}</span>
    </button>
  </div>

  <!-- Helpful hint when no characteristics chosen yet. -->
  <div *ngIf="builderControlsExpanded && (group.characteristics || []).length === 0" class="rgb-hint">
    <mat-icon>info_outline</mat-icon>
    <span i18n="@@Pick characteristics hint">
      Pick one or more characteristics above to define the matrix.
    </span>
  </div>

  <!-- Matrix ────────────────────────────────────────────────────── -->
  <app-rate-group-matrix *ngIf="(group.characteristics || []).length > 0"
                         [characteristics]="group.characteristics"
                         [axes]="axes"
                         [cells]="group.cells"
                         [rowAxes]="group._rowAxes || []"
                         [colAxes]="group._colAxes || []"
                         [readOnly]="readOnly"
                         [hideLayoutBins]="!builderControlsExpanded"
                         (cellAmountChange)="setCellAmount($event.key, $event.amount)"
                         (cellInfeasibleToggle)="toggleCellInfeasible($event)"
                         (axesLayoutChange)="setAxesLayout($event.rowAxes, $event.colAxes)">
  </app-rate-group-matrix>

</div>

